import type * as PIXI from 'pixi.js';
import type { IObservableValue } from './reactivity';
import { observable } from './reactivity';

/**
 * Makes a PIXI container's visibility observable.
 *
 * PIXI has no notion of mobx and we do not patch it, so this redefines `visible` on one container as an
 * accessor over an observable. Reads and writes from either side go through it.
 */
export class ObservableContainerVisibility {
    readonly #visible: IObservableValue<boolean>;

    constructor(container: PIXI.Container) {
        this.#visible = observable.box(container.visible);

        Object.defineProperty(container, 'visible', {
            get: () => this.#visible.get(),
            set: (value: boolean) => this.#visible.set(value),
            configurable: true,
            enumerable: true,
        });
    }

    get visible(): boolean {
        return this.#visible.get();
    }

    set visible(value: boolean) {
        this.#visible.set(value);
    }
}
